import { Component, signal } from '@angular/core';

import { ForgotPasswordFormComponent } from '../../components/forms/forgot-password-form/forgot-password-form.component';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ForgotPasswordFormComponent
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  readonly isLoading = signal<boolean>(false);

  constructor(private readonly router: Router,
    private readonly userService: UserService,
    private readonly messageService: MessageService) { }

  forgotPassword(fields: { email: string; }) {
    const { email } = fields;

    this.userService.forgotPassword(email)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Email enviado com sucesso! Verifique sua caixa de entrada.',
            life: 4000
          });
          this.router.navigate(['/login']);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro!',
            life: 4000
          });
        }
      });
  }
}
